// @avantia common-code
import {
  createEmptyClientQuestionSetState,
  createEmptyFeatureToggleState,
  createEmptyUserInterfaceState,
  registerGetInitialState
} from '../engineClient/reducers/initialState';
import { HpPoliciesState } from '../types/policyTypes';
import { HpClaimEnquiryResultState, HpGlobalState } from '../types/stateTypes';
import { createEmptyUserState } from './userReducer';

export function createEmptyPoliciesState(): HpPoliciesState {
  const policiesState: HpPoliciesState = {};
  return policiesState;
}

export function createEmptyClaimEnquiryResultState(): HpClaimEnquiryResultState {
  const claimEnquiryResultState: HpClaimEnquiryResultState = {
    heading: '',
    subHeading: '',
    claimReferenceNumber: '',
    claimReferenceText: '',
    claimJourneyComplete: false,
    submissionType: undefined
  };
  return claimEnquiryResultState;
}

export function getInitialState(): HpGlobalState {
  return {
    userInterface: createEmptyUserInterfaceState(),
    user: createEmptyUserState(),
    questionSet: createEmptyClientQuestionSetState(),
    featureToggles: createEmptyFeatureToggleState(),
    policies: createEmptyPoliciesState(),
    claimEnquiryResult: createEmptyClaimEnquiryResultState()
  };
}

registerGetInitialState(getInitialState);
